// Handlers
import textColorCustomStyleFn from './textColorCustomStyleFn';

export default () => ({
    customStyleFn: textColorCustomStyleFn,
});
